import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useLuminaryAnalytics } from "./luminary_analytics";
import { partnerConfig } from "./luminary_partner_config";

const Theme = lazyWithRetry(() => import("./luminary_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 9", value: { minCapacity: 1, maxCapacity: 9 } },
  { label: "10+", value: { minCapacity: 10 } },
];

export function OfferingLuminaryListingMeetingRoom() {
  useLuminaryAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        showTalkWithUsPrompt={true}
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title: "Meeting Rooms",
          description:
            "Luminary features eleven private conference rooms for meetings, including two Boardrooms. Our conference rooms include seating from 4-6 people. Our Boardrooms hold up to 15 and 25 respectively. All of our conference rooms are outfitted with wall-mounted flat screen TVs and whiteboards, perfect for presentations, meetings, and brainstorming sessions!",
        }}
      />
    </Fragment>
  );
}
